/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { launcherJudge } from "../funcs/launcherJudge.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { LauncherJudgment } from "../models/components/launcherjudgment.js";
import {
  LauncherJudgeRequest,
  LauncherJudgeSecurity,
} from "../models/operations/launcherjudge.js";
import { unwrapAsync } from "../types/fp.js";

export class Launcher extends ClientSDK {
  /**
   * judge launcher
   *
   * @remarks
   * Judge which of the supplied command palette candidates the typed query refers to, what kind of action it asks for, and whether the intent is settled enough to act on Enter. Returns probability distributions rather than text. When no intent service is configured the response carries disabled=true and the palette falls back to fuzzy ordering.
   */
  async judge(
    request: LauncherJudgeRequest,
    security?: LauncherJudgeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<LauncherJudgment> {
    return unwrapAsync(launcherJudge(
      this,
      request,
      security,
      options,
    ));
  }
}
